import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
const SignupRequestLoadingIllustration = {
  [Flow.Purchase]: 'payments-subscriptions'
};
export const getSignupRequestLoadingImageConfig = () => {
  const flowKey = getFlowKey();
  if (SignupRequestLoadingIllustration[flowKey]) {
    return {
      imageUrl: SignupRequestLoadingIllustration[flowKey],
      isIllustration: true,
      illustrationHeight: '300px'
    };
  }
  return {
    imageUrl: 'greeting-morning',
    isIllustration: true,
    illustrationHeight: '200px'
  };
};